/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import moment from "moment";
import { cloneDeep } from 'lodash';
import { handleCalculateExtraDaysInLeapYearsDateRange } from "utils/src/DateUtil";

export const handleQuestionsInitialAdjustments = async (
  questionnaire,
  setPeriodicityText,
  operation,
  permissions,
  token,
  useMaxLimClaimRequest,
  dataReference = new Date(),
  refOperation,
  brokerList,
  emissionDates,
  vigencyParams,
  handleGetProductPlanVigencyParams,
  product,
  GENERATE_PERMISSION
) => {
  if (handleGetProductPlanVigencyParams && operation) {
    let inceptionDate = questionnaire.find(
      qst => qst.idQuestion === 3447
    )?.answer;

    if (
      operation?.isRenewal &&
      operation.operationMetadata?.unchangedRiskQuestionnaire
    ) {
      inceptionDate = emissionDates.expiryDate;
    } else if (operation && operation.idDomain !== 26) {
      inceptionDate = emissionDates.inceptionDate;
    }

    const idDomainOperation = operation?.isRenewal ? operation?.operationParent?.idDomain : operation?.idDomain;
    vigencyParams = await handleGetProductPlanVigencyParams({
      idProductPlan: operation?.idProductPlan,
      idDomainOperation,
      inceptionDate
    });
  }

  for (const question of questionnaire) {
    if (refOperation) {

      question.disabled = ![3406, 3413, 3417].includes(question.idQuestion) ? false : true;
      question.idQuestionnaireAnswers = null;

      if ([3458, 3501, 3002, 3448, 3447, 3449].includes(question.idQuestion)) {
        question.answer = null;
        question.answerJson = null;
        question.idAnswerOption = null;
      }

      if (question.behaviorObject?.ignoreCloning || [270, 271].includes(question.idDomainQuestion)) {
        question.answer = null;
        question.answerJson = null;
        question.idAnswerOption = null;
      }

      if (question.childrenQuestions) {
        question.childrenQuestions.map(child => {
          child.idQuestionnaireAnswers = null
          child.idQuestionnaireAnswersRoot = null
          child.idQuestionnaireAnswersParent = null

          return child;
        })
      }
    }

    /*  if (question.idQuestion === 1627) {
       const questionModality = questionnaire.find(qst => [3403].includes(qst.idQuestion));  
       
       // Verificar se alguma das modalidades selecionadas é 7118
       let isModality7118 = false;
       if (questionModality?.answer) {
         try {
           const selectedModalities = Array.isArray(questionModality.answer) 
             ? questionModality.answer 
             : JSON.parse(questionModality.answer);
           isModality7118 = selectedModalities.some(modality => modality.idAnswerOption === 7118);
         } catch (error) {
           // Fallback para formato antigo
           isModality7118 = questionModality?.idAnswerOption === 7118;
         }
       } else {
         isModality7118 = questionModality?.idAnswerOption === 7118;
       }
       
       question.disabled = isModality7118;
     } */


    if (question.idQuestion === 1602 && !question.idAnswerOption) {
      question.idAnswerOption = question.behaviorObject.defaultValue || null;
    }

    if (question.idQuestion === 1424) {
      const qst = questionnaire.find(v => v.idQuestion === 1397);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 6816;
    }

    if (question.idQuestion === 1559) {
      question.behaviorObject.isRequired = true;
    }

    if (question.idQuestion === 3500 && !question.answer) {
      question.answer = moment(dataReference).startOf('day').format('YYYY-MM-DD')
    }

    if ([1587, 3387].includes(question.idQuestion)) {
      if (!question.answer) {
        question.behaviorObject.disabled = false;
        question.behaviorObject.isReadOnly = false;
      }

      question.childrenQuestions.map(qst => {
        if ([1819, 1631].includes(qst.idQuestion) && !qst.answer) {
          qst.behaviorObject.disabled = false;
          qst.behaviorObject.isReadOnly = false;
        }
        return qst;
      });
    }

    if (question.idQuestion === 3501) {
      question.answer = question.answer || question.behaviorObject.defaultValue;
    }

    if (!permissions || GENERATE_PERMISSION) {
      if ([1518, 1523].includes(question.idQuestion)) {
        const qst = questionnaire.find(v => v.idQuestion === 3386);
        question.disabled = !qst.answer;
      }
    }

    if (question.idQuestion === 1519) {
      question.disabled = true;
    }

    if (question.idQuestion === 3400) {
      if (operation?.isRenewal) {
        const { dsAnswerOption, idAnswerOption } = question.answerOptions.find(
          answerOption => answerOption.idAnswerOption === 8927
        );
        question.answer = dsAnswerOption;
        question.idAnswerOption = idAnswerOption;
      }

      questionnaire = questionnaire.map(qst => {
        if ([1847, 3401, 3402, 1850].includes(qst.idQuestion)) {
          qst.visibleQuestion = question.idAnswerOption === 8927;
        } else if ([1576, 1804].includes(qst.idQuestion)) {
          const idAnswerOption = question?.idAnswerOption || question?.behaviorObject?.defaultValue || null;
          qst.visibleQuestion = [8926, 8927].includes(idAnswerOption);
        }

        return qst;
      });
    }

    if (token && permissions && !GENERATE_PERMISSION) {
      const { idPersonRoot, applicationPersonRoot, rootFirstName } = token.login_response.ret_value;

      if (question.idQuestion === 3386 && !question.answer && idPersonRoot !== applicationPersonRoot) {
        if (brokerList?.length > 0 && brokerList[0].id === idPersonRoot) {
          question.answer = JSON.stringify({
            id: brokerList[0].id,
            value: `${brokerList[0].insurerBrokerId} - ${brokerList[0].personName}`
          });
          question.answerJson = question.answer;
        } else {
          question.answer = JSON.stringify({
            id: idPersonRoot,
            value: `${idPersonRoot} - ${rootFirstName}`
          });
          question.answerJson = question.answer;
        }
      }

      if (question.idQuestion === 1518) {
        question.behaviorObject.brokerIdSelected = idPersonRoot || null;
      }
    } else if (permissions && token) {
      if (question.idQuestion === 3386 && question.answer) {
        try {
          const brokerId = JSON.parse(question.answer).id;
          questionnaire = questionnaire.map(qst => {
            if (qst.idQuestion === 1518) {
              qst.behaviorObject.brokerIdSelected = brokerId || null;
            }
            return qst;
          })
        } catch {

        }
      }
    }

    if (question.idQuestion === 1629) {
      const qst = questionnaire.find(v => v.idQuestion === 1628);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 7239;
    }

    if (question.idQuestion === 3436) {
      const qst = questionnaire.find(v => v.idQuestion === 3435);
      const { idAnswerOption } = qst;
      question.visibleQuestion = idAnswerOption === 8979;
      // Se não for visível, limpar os valores
      if (idAnswerOption !== 8979) {
        question.answer = '';
        question.idAnswerOption = null;
      }
    }

    if (question.idQuestion === 3472) {
      const qst3435 = questionnaire.find(v => v.idQuestion === 3435);
      const qst3436 = questionnaire.find(v => v.idQuestion === 3436);

      // Se 3435 não for 8979 (ou seja, 3436 está invisível), limpar 3472
      if (qst3435?.idAnswerOption !== 8979) {
        question.idAnswerOption = null;
      } else if (qst3436?.answer) {
        const value = parseFloat(qst3436.answer.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
        question.idAnswerOption = value < 100000 ? 9025 : 9026;
      }
    }

    if (question.idQuestion === 3473) {
      const qst3425 = questionnaire.find(v => v.idQuestion === 3425);

      if (qst3425?.answer) {
        const value = parseFloat(qst3425.answer.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
        question.idAnswerOption = value <= 15000000 ? 9027 : 9028;
      }
    }

    if (question.idQuestion === 1630) {
      question.disabled = !!(operation);
    }

    if (question.idQuestion === 1557) {
      question.disabled = !!(operation);
    }

    if (question.idQuestion === 1569) {
      question.disabled = !!(operation);

      const isInAnalysis = question.answerOptions.find(v => v.idAnswerOption === question.idAnswerOption)?.idDomain === 40;
      if (isInAnalysis) {
        questionnaire.find(v => v.idQuestion === 3448).behaviorObject.isWarningByHiddenQuestions = true;
      }
    }

    if ([3403].includes(question.idQuestion)) {
      const answerOption = question.answerOptions.find(answerOption => answerOption.idAnswerOption === question.idAnswerOption);
      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 1619) {
          qst.behaviorObject.isRequired = [7113, 7119, 7120].includes(answerOption?.idAnswerOption)
            ? false
            : [7116].includes(answerOption?.idAnswerOption)
              ? true
              : qst.behaviorObject?.isRequired
        }
        return qst;
      })
    }

    if (question.idQuestion === 3453 && question?.childrenQuestions?.length) {
      const { idAnswerOption } = questionnaire.find(v => v.idQuestion === 3452) || {};
      const participation = questionnaire.find(v => v.idQuestion === 3454);
      question.visibleQuestion = idAnswerOption === 8984;
      participation.visibleQuestion = idAnswerOption === 8984;
      question.childrenQuestions.map(qst => {
        qst.visibleQuestion = idAnswerOption === 8984;
        return qst;
      });
    }

    if (question.idQuestion === 1519) {
      question.disabled = true;
    }

    if (question.idQuestion === 1587) {
      if (question.answer) {
        questionnaire.map(qst => {
          if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(qst.idQuestion)) {
            qst.behaviorObject.isRequired = true;
            if (question.answer.length == 14 && qst.idQuestion == 1588) qst.disabled = true;
          }
          return qst;
        })
        question.childrenQuestions.map(item => {
          if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(item.idQuestion)) {
            item.behaviorObject.isRequired = true;
            if (question.answer.length == 14 && item.idQuestion == 1588) item.disabled = true;
          }
        })
      } else {
        questionnaire.map(qst => {
          if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(qst.idQuestion)) {
            qst.behaviorObject.isRequired = false;
          }
          return qst;
        })
        question.childrenQuestions.map(item => {
          if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(item.idQuestion)) {
            item.behaviorObject.isRequired = false;
          }
        })
      }
    }

    if (question.idQuestion === 3387) {
      if (question.answer) {
        questionnaire = questionnaire.map(qst => {
          if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(qst.idQuestion)) {
            qst.behaviorObject.isRequired = true;
            if (question.answer.length == 14 && qst.idQuestion == 3388) qst.disabled = true;
          }
          return qst;
        })
        question.childrenQuestions.map(item => {
          if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(item.idQuestion)) {
            item.behaviorObject.isRequired = true;
            if (question.answer.length == 14 && item.idQuestion == 3388) item.disabled = true;
          }
        })
      } else {
        questionnaire = questionnaire.map(qst => {
          if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(qst.idQuestion)) {
            qst.behaviorObject.isRequired = false;
          }
          return qst;
        })
        question.childrenQuestions.map(item => {
          if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(item.idQuestion)) {
            item.behaviorObject.isRequired = false;
          }
        })

      }
    }
    if (question.idQuestion === 3372) {
      if (question.answer) {
        questionnaire = questionnaire.map(qst => {
          if ([1630, 3373].includes(qst.idQuestion)) {
            qst.behaviorObject.isRequired = true;
            if (question.answer.length == 14 && qst.idQuestion == 3388) qst.disabled = true;
          }
          return qst;
        })
        question.childrenQuestions.map(item => {
          if ([1630, 3373].includes(item.idQuestion)) {
            item.behaviorObject.isRequired = true;
            if (question.answer.length == 14 && item.idQuestion == 3388) item.disabled = true;
          }
        })
      }
    }

    if (question.idQuestion === 3449) {
      question.disabled = true;
    }

    if (question.idQuestion === 3447) {
      const maxRetroactiveDate = vigencyParams.maxRetroactiveDate;
      question.behaviorObject.fieldMinValue = maxRetroactiveDate;

      if (operation?.isRenewal && maxRetroactiveDate === 0) {
        question.behaviorObject.fieldMinValue = dateDiffInDay(
          new Date(dataReference),
          new Date(emissionDates.expiryDate)
        );
      }

      if (
        operation?.isRenewal &&
        operation.operationMetadata?.unchangedRiskQuestionnaire
      ) {
        question.answer = emissionDates.expiryDate;
      } else if (!question.answer && operation && operation.idDomain !== 26) {
        question.answer = emissionDates.inceptionDate;
      }
    }

    if (question.idQuestion === 3449 &&
      operation?.isRenewal &&
      operation.operationMetadata?.unchangedRiskQuestionnaire
    ) {
      const validDays = dateDiffInDay(
        new Date(emissionDates.inceptionDate),
        new Date(emissionDates.expiryDate)
      );

      const extraDaysInLeapYears = handleCalculateExtraDaysInLeapYearsDateRange({
        startDate: emissionDates.inceptionDate,
        dayRange: validDays
      });

      const validDaysWithoutLeapYearDays = (validDays - extraDaysInLeapYears);

      const days = handleCalculateExtraDaysInLeapYearsDateRange({
        startDate: emissionDates.expiryDate,
        dayRange: validDaysWithoutLeapYearDays
      });

      question.answer = (validDaysWithoutLeapYearDays + days);
    }

    if (question.idQuestion === 3448) {
      if (
        operation?.isRenewal &&
        operation.operationMetadata?.unchangedRiskQuestionnaire
      ) {
        const validDays = dateDiffInDay(
          new Date(emissionDates.inceptionDate),
          new Date(emissionDates.expiryDate)
        );

        const extraDaysInLeapYears = handleCalculateExtraDaysInLeapYearsDateRange({
          startDate: emissionDates.inceptionDate,
          dayRange: validDays
        });

        const validDaysWithoutLeapYearDays = (validDays - extraDaysInLeapYears);

        const days = handleCalculateExtraDaysInLeapYearsDateRange({
          startDate: emissionDates.expiryDate,
          dayRange: validDaysWithoutLeapYearDays
        });

        const newPolicyValidDays = (validDaysWithoutLeapYearDays + days);

        const endTerm = moment((moment(emissionDates.expiryDate).add((+newPolicyValidDays), 'days'))).format('YYYY-MM-DD');
        const {
          minValidityLimitInDays,
          maxValidityLimitInDays
        } = handleMaxTermValueInDays(dataReference, emissionDates.expiryDate, vigencyParams);

        question.answer = endTerm;
        question.behaviorObject.fieldMaxValue = maxValidityLimitInDays;

        if (minValidityLimitInDays) question.behaviorObject.fieldMinValue = minValidityLimitInDays;
      } else if (operation?.idDomain === 26 || refOperation) {
        const startTerm = questionnaire.find(qst => qst.idQuestion === 3447)?.answer;
        const modalityQst = questionnaire.find(qst => [3403].includes(qst.idQuestion));

        // Verificar se há modalidades selecionadas
        let hasModality = false;
        if (modalityQst?.answer) {
          try {
            const selectedModalities = Array.isArray(modalityQst.answer)
              ? modalityQst.answer
              : JSON.parse(modalityQst.answer);
            hasModality = selectedModalities.length > 0;
          } catch (error) {
            hasModality = !!modalityQst?.idAnswerOption;
          }
        } else {
          hasModality = !!modalityQst?.idAnswerOption;
        }

        if (startTerm && hasModality) {
          const {
            minValidityLimitInDays,
            maxValidityLimitInDays
          } = handleMaxTermValueInDays(dataReference, startTerm, vigencyParams);
          question.behaviorObject.fieldMaxValue = maxValidityLimitInDays;
          if (minValidityLimitInDays) question.behaviorObject.fieldMinValue = minValidityLimitInDays;
        }
      } else if (!question.answer && operation && operation.idDomain !== 26) {
        question.answer = emissionDates.expiryDate;
      }
    }

    //endorsement inception date 
    if (question.idQuestion === 3495 && operation && operation.idDomain !== 26) {
      const endorsementNotPreAgreedType = questionnaire.find(
        qst => qst.idQuestion === 3530
      )?.idAnswerOption;

      if (!question.answer) {
        question.answer = endorsementNotPreAgreedType === 9035 ?
          emissionDates.expiryDate :
          moment(dataReference).startOf('day').format('YYYY-MM-DD');
      }

      //rules endorsement adjustments and corrections
      if (operation.idDomain === 254) {
        question.behaviorObject.fieldMinValue = dateDiffInDay(
          new Date(dataReference),
          new Date(emissionDates.inceptionDate)
        );

        // question.behaviorObject.fieldMaxValue = dateDiffInDay(
        //   new Date(dataReference),
        //   new Date(
        //     new Date(emissionDates.expiryDate).setDate(new Date(emissionDates.expiryDate).getDate() - 1)
        //   )
        // );
        //rules endorsement not pre agreed
      } else if (operation.idDomain === 398) {
        //with extension
        if ([9035, 8169].includes(endorsementNotPreAgreedType)) {
          question.disabled = true;
          question.behaviorObject.isReadOnly = true;
        } else {
          question.behaviorObject.fieldMinValue = dateDiffInDay(
            new Date(dataReference),
            new Date(emissionDates.inceptionDate)
          );

          // question.behaviorObject.fieldMaxValue = dateDiffInDay(
          //   new Date(dataReference),
          //   new Date(
          //     new Date(emissionDates.expiryDate).setDate(new Date(emissionDates.expiryDate).getDate() - 1)
          //   )
          // );
        }
        //rules endorsement cancellation
      } else if (operation?.idDomain === 400) {
        question.behaviorObject.fieldMinValue = dateDiffInDay(
          new Date(dataReference),
          new Date(emissionDates.inceptionDate)
        );

        // question.behaviorObject.fieldMaxValue = dateDiffInDay(
        //   new Date(dataReference),
        //   new Date(emissionDates.expiryDate)
        // );
      }
    }

    //endorsement expiry date
    if (question.idQuestion === 3499 && operation && operation.idDomain !== 26) {
      const endorsementNotPreAgreedType = questionnaire.find(
        qst => qst.idQuestion === 3530
      )?.idAnswerOption;

      if (!question.answer && ![9035, 9036].includes(endorsementNotPreAgreedType)) {
        question.answer = emissionDates.expiryDate;
      }

      const {
        minValidityLimitInDays,
        maxValidityLimitInDays
      } = handleMaxTermValueInDays(dataReference, emissionDates.inceptionDate, vigencyParams);

      question.behaviorObject.fieldMaxValue = maxValidityLimitInDays;
      if (minValidityLimitInDays) question.behaviorObject.fieldMinValue = minValidityLimitInDays;

      //rules endorsement not pre agreed
      if (operation.idDomain === 398) {
        //with extension
        if (endorsementNotPreAgreedType === 9035) {
          question.disabled = false;
          question.behaviorObject.isReadOnly = false;

          question.behaviorObject.fieldMinValue = dateDiffInDay(
            new Date(dataReference),
            new Date(
              new Date(emissionDates.expiryDate).setDate(new Date(emissionDates.expiryDate).getDate() + 1)
            )
          );
          //with reduction
        } else if (endorsementNotPreAgreedType === 9036) {
          question.disabled = false;
          question.behaviorObject.isReadOnly = false;

          const endorsementInceptionDate = questionnaire.find(
            qst => qst.idQuestion === 3495
          )?.answer;

          const minDateForCurrentDate = dateDiffInDay(
            new Date(dataReference),
            new Date(endorsementInceptionDate)
          );

          question.behaviorObject.fieldMinValue = minDateForCurrentDate > minValidityLimitInDays ?
            minDateForCurrentDate : minValidityLimitInDays
            ;

          question.behaviorObject.fieldMaxValue = dateDiffInDay(
            new Date(dataReference),
            new Date(
              new Date(emissionDates.expiryDate).setDate(new Date(emissionDates.expiryDate).getDate())
            )
          );
        }
      }
    }

    if (question.idQuestion === 1804) question.behaviorObject.sectionName = 'PARTICIPATION';

    if (question.idQuestion === 1847) {
      if (operation?.isRenewal && !refOperation && (operation.operationMetadata?.unchangedRiskQuestionnaire || !question.answer)) {
        const { dsAnswerOption, idAnswerOption } = question.answerOptions.find(
          answerOption => answerOption.idAnswerOption === 7429
        );
        question.answer = dsAnswerOption;
        question.idAnswerOption = idAnswerOption;
      }
    }

    if (question.idQuestion === 3402) {
      if (operation?.isRenewal && !refOperation && (operation.operationMetadata?.unchangedRiskQuestionnaire || !question.answer)) {
        const refNumber = operation?.operationParent?.operationReferenceNumber || '';
        question.answer = refNumber;
      }
    }

    if (question.idQuestion === 1850) {
      if (operation?.isRenewal && !refOperation && (operation.operationMetadata?.unchangedRiskQuestionnaire || !question.answer)) {
        const isClaim = operation?.creditAnalysis?.idAnswerOptionIndemnifiedInsurance === 7273 ||
          operation?.creditAnalysis?.idAnswerOptionLossExpectation === 7275;

        const { dsAnswerOption, idAnswerOption } = question.answerOptions.find(
          answerOption => answerOption.idAnswerOption === (isClaim ? 7431 : 7432)
        );

        question.answer = dsAnswerOption;
        question.idAnswerOption = idAnswerOption;
      }
    }

    if (question.idQuestion === 3401) {
      if (operation?.isRenewal && !refOperation && (operation.operationMetadata?.unchangedRiskQuestionnaire || !question.answer)) {
        const { dsAnswerOption, idAnswerOption } = question.answerOptions.find(
          answerOption => answerOption.idAnswerOption === 7510 //SOMPO
        );

        question.answer = dsAnswerOption;
        question.idAnswerOption = idAnswerOption;
      }
    }

    if (question.idQuestion === 1854) {
      const idAnswerOption = question?.idAnswerOption || +question.behaviorObject?.defaultValue;
      question.disabled = idAnswerOption === 7466;
    }

    if (question.idQuestion === 1857) {
      if (operation?.isRenewal && !refOperation && (operation.operationMetadata?.unchangedRiskQuestionnaire || !question.idAnswerOption)) {
        const modalityQst = questionnaire.find(qst => [3403].includes(qst.idQuestion));

        // Buscar modalidades selecionadas e verificar se alguma é judicial
        let judicialModality = false;
        if (modalityQst?.answer) {
          try {
            const selectedModalities = Array.isArray(modalityQst.answer)
              ? modalityQst.answer
              : JSON.parse(modalityQst.answer);
            judicialModality = selectedModalities.some(modality =>
              [7115, 7116, 7117, 7118, 8162, 8163].includes(modality.idAnswerOption)
            );
          } catch (error) {
            judicialModality = [7115, 7116, 7117, 7118, 8162, 8163].includes(modalityQst?.idAnswerOption);
          }
        } else {
          judicialModality = [7115, 7116, 7117, 7118, 8162, 8163].includes(modalityQst?.idAnswerOption);
        }

        const days = dateDiffInDay(
          new Date(dataReference),
          new Date(emissionDates.expiryDate)
        );

        const { dsAnswerOption, idAnswerOption } = question.answerOptions.find(
          answerOption => answerOption.idAnswerOption === (judicialModality && days > 75 ? 7472 : 7473)
        );

        question.answer = dsAnswerOption;
        question.idAnswerOption = idAnswerOption;
      }
    }

    if (question.idQuestion === 3532) {
      if (
        (operation?.isRenewal || operation?.idDomain !== 26) &&
        operation?.operationMetadata?.unchangedRiskQuestionnaire
      ) {
        const valueIS = questionnaire.find(qst => [3434].includes(qst.idQuestion) && qst?.answer)?.answer;
        if (valueIS && !question.answer) question.answer = valueIS;
      }
    }

    if (question.idQuestion === 1553 && [253, 254, 255, 256, 395, 396, 398, 400, 410, 624].includes(operation?.idDomain)) {
      question.behaviorObject.isReadOnly = (!permissions.NBI_REQUEST_APPROVE_REJECT && (question.answer || question.answer !== ''));
    }

    if (question.idQuestion === 3483) {
      const question3372 = questionnaire.find(qst => qst.idQuestion === 3372);
      if (question3372 && question3372.answer?.length > 11) {
        question.visibleQuestion = false;
      } else {
        question.visibleQuestion = true;
      }
    }

    if (question.idQuestion === 3530) {
      const endorsementNotPreAgreedType = question?.idAnswerOption;

      if (endorsementNotPreAgreedType) {
        questionnaire = questionnaire.map(qst => {
          if (
            [9035, 9036].includes(endorsementNotPreAgreedType) &&
            [3434].includes(qst.idQuestion)
          ) {
            qst.disabled = true;
            qst.behaviorObject.isReadOnly = true;
          }
          return qst;
        });
      }
    }

    if (question.idQuestion === 3002 && !question?.answer && product) {
      question.answer = product?.SUSEP_PROCESS || '';
    }

    if (question.idQuestion === 3431) {
      const { idAnswerOption } = question;
      const question3470 = questionnaire.find(qst => qst.idQuestion === 3470);

      if (question3470) {
        if (idAnswerOption === 8976) {
          question3470.fieldMask = {
            "type": "percentage",
            "mask": "% num",
            "blocks": {
              "num": {
                "mask": 0,
                "scale": 5,
                "signed": true,
                "normalizeZeros": false,
                "padFractionalZeros": true,
                "thousandsSeparator": ",",
                "radix": ".",
                "mapToRadix": [
                  ".",
                  ","
                ],
                "min": -100,
                "max": 100
              }
            }
          };
        } else {
          // Para 8975 ou qualquer outra opção, usar currency
          question3470.fieldMask = {
            "type": "currency",
            "mask": 0,
            "scale": 2,
            "signed": false,
            "normalizeZeros": false,
            "padFractionalZeros": true,
            "radix": ",",
            "thousandsSeparator": ".",
            "mapToRadix": [
              ".",
              ","
            ],
            "max": 999999999999.99,
            "min": -999999999999.99
          };
        }
      }
    }

    if (question.idQuestion === 3434 && [254, 398, 400].includes(operation?.idDomain)) {
      question.visibleQuestion = !!question.answer;
    }
  }

  // Calcular question 3471 na inicialização se os valores já existem
  const question3431 = questionnaire.find(qst => qst.idQuestion === 3431);
  const question3428 = questionnaire.find(qst => qst.idQuestion === 3428);
  const question3470 = questionnaire.find(qst => qst.idQuestion === 3470);
  const question3471 = questionnaire.find(qst => qst.idQuestion === 3471);

  if (question3431 && question3428 && question3470 && question3471 &&
    question3428.answer && question3470.answer) {
    const isPercentage = question3431.idAnswerOption === 8976;
    const valorObra = parseFloat(question3428.answer?.replace(/[^\d,]/g, '')?.replace(',', '.')) || 0;
    const valorInputado = parseFloat(question3470.answer?.replace(/[^\d,]/g, '')?.replace(',', '.')) || 0;

    let valorCalculado = 0;

    if (isPercentage) {
      // Se for percentual, calcula: (valor inputado / 100) * valor da obra
      valorCalculado = (valorInputado / 100) * valorObra;
    } else {
      // Se for valor em R$, apenas replica o valor
      valorCalculado = valorInputado;
    }

    if (valorCalculado > 0 && !question3471.answer) {
      question3471.answer = valorCalculado.toFixed(2);
    }
  }

  const editRiskOnRenewal = questionnaire.find(
    qst => qst.idQuestion === 1854
  )?.idAnswerOption === 7466;

  if (operation?.isRenewal && editRiskOnRenewal) {
    questionnaire = questionnaire.map(qst => {
      if ([1553, 1558, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1732].includes(qst.idQuestion)) {
        qst.disabled = false;
        qst.behaviorObject.isReadOnly = false;
      }
      return qst;
    });
  }

  const policyInceptionDate = questionnaire.find(
    qst => qst.idQuestion === 3447
  )?.answer;

  if (policyInceptionDate) {
    const { diffDays, validity10YearsLimitInDays } = handleGetRangeContractVigency({ dataReference, startDate: policyInceptionDate });
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1555) {
        qst.behaviorObject.fieldMinValue = diffDays;
        qst.behaviorObject.fieldMaxValue = validity10YearsLimitInDays;
      } else if (qst.idQuestion === 1556) {
        qst.behaviorObject.fieldMinValue = diffDays + 1;
        qst.behaviorObject.fieldMaxValue = validity10YearsLimitInDays;
      }
      return qst;
    });
  }

  return questionnaire;
}

export const handleQuestionBlur = async (
  question,
  value,
  questionnaire,
  setFilteredQuestionnaire,
  setFieldValue,
  mc,
  useGetProcessInfoRequest,
  selectedCoInsurersPercentage,
  globalQuestionnaire,
) => {
  try {
    let saveFilteredQuestionnaire = false;

    if (question.idQuestion === 1553) {
      if (!value) return;

      saveFilteredQuestionnaire = true;

      try {
        const { data: { ret_value: { tribunal, vara } } } = await useGetProcessInfoRequest({
          processNumber: value
        })
        console.log({ tribunal, vara })

        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 1815) {
            return { ...qst, answer: tribunal };
          }

          if (qst.idQuestion === 1814) {
            return { ...qst, answer: vara };
          }

          return qst
        })

      } catch (error) {
        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 1814) {
            return { ...qst, answer: '' };
          }

          if (qst.idQuestion === 1815) {
            return { ...qst, answer: '' };
          }

          return qst
        })

        if (error.response.data.ret_msg_details) {
          mc.error(error.response.data.ret_msg_details);
        } else {
          mc.error("Erro ao buscar informações do processo");
        }
      }
    }

    if (question.idQuestion === 1576) {
      if (selectedCoInsurersPercentage >= 99) {
        setFieldValue && setFieldValue(question.key, '');
        mc.error("A participação no cosseguro não deve ultrapassar 100%. Por favor, ajuste a participação do cosseguro.");
        return;
      }

      setFilteredQuestionnaire(globalQuestionnaire.map(qst => {
        if (qst.idQuestion === 1804) {
          qst.answer = 100 - selectedCoInsurersPercentage;
          setFieldValue && setFieldValue(qst.key, qst.answer);
        }
        return qst;
      }))
    }

    if (saveFilteredQuestionnaire) setFilteredQuestionnaire(questionnaire);
  } catch (e) {
    console.log("error", e)
  }
}

export const handleQuestionChange = async (
  question,
  value,
  questionnaire,
  setFilteredQuestionnaire,
  setFieldValue,
  setCurrentModality,
  token,
  getPersonRequest,
  globalQuestionnaire,
  mc,
  setStateGroup,
  coBrokerGroup,
  setQuestionnaireAnswersToDelete,
  useMaxLimClaimRequest,
  operation,
  isCorrectedAmountUpdatable,
  dataReference = new Date(),
  handleCheckConsumption,
  handleGetProductPlanVigencyParams,
  vigencyParams,
  setFieldError

) => {
  let saveFilteredQuestionnaire = false;

  // Função auxiliar para calcular o valor da question 3471
  const calculateQuestion3471 = (questionnaire, setFieldValue) => {
    const question3431 = questionnaire.find(qst => qst.idQuestion === 3431);
    const question3428 = questionnaire.find(qst => qst.idQuestion === 3428);
    const question3470 = questionnaire.find(qst => qst.idQuestion === 3470);
    const question3471 = questionnaire.find(qst => qst.idQuestion === 3471);
    if (question3431 && question3428 && question3470 && question3471) {
      const isPercentage = question3431.idAnswerOption === 8976;
      const valorObra = parseFloat(question3428.answer || 0);
      const valorInputado = parseFloat(question3470.answer || 0);

      let valorCalculado = 0;

      if (isPercentage) {
        // Se for percentual, calcula: (valor inputado / 100) * valor da obra
        valorCalculado = (valorInputado / 100) * valorObra;
      } else {
        // Se for valor em R$, apenas replica o valor
        valorCalculado = valorInputado;
      }

      question3471.answer = valorCalculado.toFixed(2);
      setFieldValue && setFieldValue(question3471.key, valorCalculado.toFixed(2));
      return true;
    }
    return false;
  };


  if (question.fieldMask?.type === "cpfCnpj") {
    saveFilteredQuestionnaire = true;
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === question.idQuestion) {
        if (String(value).length > 11) {
          qst.behaviorObject.searchQueryId = "fitGetSerproCpnj";
          qst.behaviorObject.canGenerate = true;
        } else {
          qst.behaviorObject.searchQueryId = "";
          qst.behaviorObject.canGenerate = true;
        }
      }

      return qst;
    });
  }

  if (question.idQuestion === 1397) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1424) {
        qst.visibleQuestion = idAnswerOption === 6816;
      }

      return qst;
    })
  }

  if (question.idQuestion === 3272) {
    saveFilteredQuestionnaire = true;

    // Função para converter string de valor em número
    const parseMoneyValue = (str) => {
      if (!str) return 0;
      return parseFloat(str.replace(/[R$\s.]/g, '').replace(',', '.'));
    };

    const parseAnswerOptionRange = (dsAnswerOption) => {
      if (!dsAnswerOption) return { min: 0, max: Infinity };

      // Para "Acima de R$ X"
      if (dsAnswerOption.includes('Acima de')) {
        const match = dsAnswerOption.match(/R\$\s*([\d.,]+)/);
        const minValue = match ? parseMoneyValue(match[1]) : 0;
        return { min: minValue, max: Infinity };
      }

      // Para ranges "De R$ X a R$ Y"
      const rangeMatch = dsAnswerOption.match(/De R\$\s*([\d.,]+)\s*a R\$\s*([\d.,]+)/);
      if (rangeMatch) {
        return {
          min: parseMoneyValue(rangeMatch[1]),
          max: parseMoneyValue(rangeMatch[2])
        };
      }

      return { min: 0, max: Infinity };
    };

    // Função para encontrar o answerOption baseado no valor
    const findAnswerOptionByValue = (answerOptions, inputValue) => {
      const numericValue = parseMoneyValue(inputValue);

      return answerOptions.find(option => {
        const range = parseAnswerOptionRange(option.dsAnswerOption);
        return numericValue >= range.min && numericValue <= range.max;
      });
    };

    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 3277) {
        const matchingOption = findAnswerOptionByValue(qst.answerOptions, value);

        if (matchingOption) {
          console.log('AnswerOption encontrado:', matchingOption);

          qst.idAnswerOption = matchingOption?.idAnswerOption;
          qst.answer = matchingOption?.dsAnswerOption;
          setFieldValue(qst.key, qst.answer);
        }
      }

      return qst;
    })
  }


  if (question.idQuestion === 1587) {
    saveFilteredQuestionnaire = true;
    if (value) {
      questionnaire = questionnaire.map(qst => {
        if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = true;
        } else {
          qst.behaviorObject.isRequired = false;
        }
        if (value.length < 14) {
          if ([1588].includes(qst.idQuestion)) {
            qst.disabled = false;
            qst.behaviorObject.isReadOnly = false;
          }
        }
        return qst;
      })
      question.childrenQuestions.map(item => {
        if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(item.idQuestion)) {
          item.behaviorObject.isRequired = true;
        } else {
          item.behaviorObject.isRequired = false;
        }
        if (value.length < 14) {
          if ([1588].includes(item.idQuestion)) {
            item.disabled = false;
            item.behaviorObject.isReadOnly = false;
          }
        }
      })
    } else {
      questionnaire = questionnaire.map(qst => {
        setFieldValue(qst.key, null)
        if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = false;
        }
        if (value.length < 14) {
          if ([1588].includes(qst.idQuestion)) {
            qst.disabled = false;
            qst.behaviorObject.isReadOnly = false;
          }
        }
        return qst;
      })
      question.childrenQuestions.map(item => {
        if ([1587, 1591, 1588, 1592, 1593, 1594, 1595, 1597, 1747, 1598, 1819].includes(item.idQuestion)) {
          item.behaviorObject.isRequired = false;
        }
        if (value.length < 14) {
          if ([1588].includes(item.idQuestion)) {
            item.disabled = false;
            item.behaviorObject.isReadOnly = false;
          }
        }
      })
    }
  }

  if (question.idQuestion === 3387) {
    saveFilteredQuestionnaire = true;
    if (value) {
      setFieldValue && setFieldValue(question.key, value);
      questionnaire = questionnaire.map(qst => {
        if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = true;
          if (qst.answer && qst.idQuestion !== 3387) {
            setFieldValue(qst.key, null)
          }
        }

        if (value.length < 14) {
          if ([3388].includes(qst.idQuestion)) {
            qst.disabled = false;
            qst.behaviorObject.isReadOnly = false;
          }

          if (qst.idQuestion === 3387) {
            qst.answer = value;
          }
        }
        return qst;
      })
      question.childrenQuestions.map(item => {
        if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(item.idQuestion)) {
          item.behaviorObject.isRequired = true;
          if (item.answer && item.idQuestion !== 3387) {
            setFieldValue(item.key, null)
          }
        }
        if (value.length < 14) {
          if ([3388].includes(item.idQuestion)) {
            item.disabled = false;
            item.behaviorObject.isReadOnly = false;
          }
        }
      })
    } else {
      questionnaire = questionnaire.map(qst => {
        if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = false;
        }
        if (value.length < 14) {
          if ([3388].includes(qst.idQuestion)) {
            qst.disabled = false;
            qst.behaviorObject.isReadOnly = false;
          }
          if (qst.idQuestion === 3387) {
            qst.answer = value;
          }
        }
        return qst;
      })
      question.childrenQuestions.map(item => {
        if ([3387, 3391, 3392, 3393, 3394, 3395, 3397, 3398, 3399, 3388, 1631].includes(item.idQuestion)) {
          item.behaviorObject.isRequired = false;
          if (item.answer && item.idQuestion !== 3387) {
            setFieldValue(item.key, null)
          }
        }
        if (value.length < 14) {
          if ([3388].includes(item.idQuestion)) {
            item.disabled = false;
            item.behaviorObject.isReadOnly = false;
          }
        }
      })
    }
  }

  if (question.idQuestion === 3372) {
    saveFilteredQuestionnaire = true;
    if (value) {
      questionnaire = questionnaire.map(qst => {
        if ([1630].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = true;
        }
        if (value.length < 14) {
          if ([1630, 3373].includes(qst.idQuestion)) {
            qst.disabled = false;
          }
        }
        if ([3483].includes(qst.idQuestion)) {
          qst.visibleQuestion = value.length > 11 ? 0 : 1;
        }

        return qst;
      })
      question.childrenQuestions.map(item => {
        if ([1630].includes(item.idQuestion)) {
          item.disabled = false;
        }
      })
    } else {
      questionnaire = questionnaire.map(qst => {
        if ([1630].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = false;
        }
        if (value.length < 14) {
          if ([1630, 3373].includes(qst.idQuestion)) {
            qst.disabled = false;
          }
        }
        return qst;
      })
      question.childrenQuestions.map(item => {
        if ([1630].includes(item.idQuestion)) {
          item.disabled = false;
        }
      })
    }
  }

  if (question.idQuestion === 1628) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1629) {
        qst.visibleQuestion = idAnswerOption === 7239;
      }
      return qst;
    })
  }

  if (question.idQuestion === 3452) {
    const { idAnswerOption } = value;
    if (idAnswerOption === 8985) {
      const idsQuestionnaireAnswers = [];
      for (const group of coBrokerGroup) {
        const ids = group.map(qst => qst.idQuestionnaireAnswers).filter(
          idQuestionnaireAnswers => idQuestionnaireAnswers
        );

        if (ids.length) idsQuestionnaireAnswers.push(...ids);
      }

      if (idsQuestionnaireAnswers.length) {
        setQuestionnaireAnswersToDelete && setQuestionnaireAnswersToDelete(
          prev => ([...prev, ...idsQuestionnaireAnswers])
        );
      }

      const resetGroup = coBrokerGroup[0].map(qst => {
        qst.answer = '';
        qst.answerJson = '';
        qst.idAnswerOption = null;
        qst.idQuestionnaireAnswers = null;
        qst.idQuestionnaireAnswersParent = null;
        qst.idQuestionnaireAnswersRoot = null;
        qst.key = null;
        qst.visibleQuestion = false;
        return qst;
      });

      setStateGroup && setStateGroup([resetGroup]);
    } else if (idAnswerOption === 8984) {
      setStateGroup && setStateGroup(prev => {
        return prev.map(group => {
          return group.map(qst => {
            qst.visibleQuestion = true;
            return qst;
          })
        })
      });
    }
  }

  if (question.idQuestion === 3435) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 3436) {
        qst.visibleQuestion = idAnswerOption === 8979;
        // Se não for 8979, limpar os valores da question 3436
        if (idAnswerOption !== 8979) {
          qst.answer = '';
          qst.idAnswerOption = null;
          setFieldValue && setFieldValue(qst.key, '');
        }
      }
      // Limpar também a question 3472 quando 3436 ficar invisível
      if (qst.idQuestion === 3472 && idAnswerOption !== 8979) {
        qst.idAnswerOption = null;
      }
      return qst;
    });
  }

  if (question.idQuestion === 3436) {
    saveFilteredQuestionnaire = true;
    const numericValue = parseFloat(value?.replace(/[^\d,]/g, '')?.replace(',', '.')) || 0;

    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 3472) {
        qst.idAnswerOption = numericValue < 100000 ? 9025 : 9026;
      }
      return qst;
    });
  }

  if (question.idQuestion === 3425) {
    saveFilteredQuestionnaire = true;
    const numericValue = parseFloat(value?.replace(/[^\d,]/g, '')?.replace(',', '.')) || 0;

    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 3473) {
        qst.idAnswerOption = numericValue <= 15000000 ? 9027 : 9028;
      }
      return qst;
    });
  }

  if (question.idQuestion === 3400) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    questionnaire = questionnaire.map(qst => {
      if ([1576, 1804].includes(qst.idQuestion)) {
        qst.visibleQuestion = [8926, 8927].includes(idAnswerOption);
      } else if ([1847, 3401, 3402, 1850].includes(qst.idQuestion)) {
        qst.visibleQuestion = idAnswerOption === 8927;
      }

      return qst;
    })
  }

  if ([3386].includes(question.idQuestion) && (value?.id || value === '')) {
    saveFilteredQuestionnaire = true;
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1518) {
        qst.behaviorObject.brokerIdSelected = value?.id || null;
        qst.disabled = !value?.id || value?.insurerBrokerId === '0';
        qst.answer = null;
        qst.answerJson = null;
        setFieldValue(qst.key, null)
      }

      if (qst.idQuestion === 1519) {
        qst.disabled = true;
        qst.answer = null;
        qst.answerJson = null;
        setFieldValue(qst.key, null)
      }

      if (qst.idQuestion === 1523) {
        qst.disabled = !value?.id;
        qst.answer = null;
        qst.answerJson = null;
        setFieldValue(qst.key, null)
      }

      return qst;
    });
  }

  if ([1518, 1392].includes(question.idQuestion) && value?.id) {
    saveFilteredQuestionnaire = true;

    if (!value.contacts) {
      const { data, status } = await getPersonRequest(null, {
        getContacts: true,
        getSicCode: true,
        idDomain: 35,
        idPerson: value.id
      });

      if (data.value && data.value.length) {
        let response = data.value[0];
        response = { ...response, id: response.idPerson };

        handleQuestionChange(
          question,
          response,
          questionnaire,
          setFilteredQuestionnaire,
          setFieldValue,
          setCurrentModality,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          handleCheckConsumption
        );
      }
    } else {
      const canConsumeLimit = handleCheckConsumption && await handleCheckConsumption({ idPerson: value.id });
      questionnaire = questionnaire.map(qst => {
        if ([1518, 1392, 1519, 1393, 1522, 1523, 1524, 1525, 1526, 1528, 1529, 1743].includes(qst.idQuestion) && !canConsumeLimit) {
          qst.answer = '';
          qst.answerJson = ''
          setFieldValue(qst.key, qst.answer);
          return qst;
        }

        if ([1518, 1392].includes(qst.idQuestion)) {
          qst.answer = JSON.stringify({ id: value.id, value: value.legalPersonId || value.ni });
          qst.answerJson = JSON.stringify({ id: value.id, value: value.legalPersonId || value.ni });
          setFieldValue(qst.key, value.legalPersonId || value.ni)
        }

        if ([1519, 1393].includes(qst.idQuestion)) {
          qst.answer = value.personName || value.nomeEmpresarial || value?.personLastName;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1522].includes(qst.idQuestion) && value?.telefones?.length) {
          qst.answer = value?.telefones[0].ddd + value.telefones[0].numero;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1523].includes(qst.idQuestion)) {
          const emailInfo = value?.contacts.find(e => e.idDomain === 32)?.contactDescription;

          qst.answer = value?.correioEletronico || emailInfo || '';
          setFieldValue(qst.key, qst.answer)
        }

        if ([1524].includes(qst.idQuestion) && value?.endereco) {
          qst.answer = value.endereco.cep;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1525].includes(qst.idQuestion) && value?.endereco) {
          qst.answer = `${value?.endereco.tipoLogradouro} ${value?.endereco.logradouro}`;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1526].includes(qst.idQuestion) && value?.endereco) {
          qst.answer = value.endereco.numero;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1528].includes(qst.idQuestion) && value?.endereco) {
          qst.answer = value.endereco.bairro;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1529].includes(qst.idQuestion) && value?.endereco) {
          qst.answer = value.endereco.uf;
          setFieldValue(qst.key, qst.answer)
        }

        if ([1743].includes(qst.idQuestion)) {
          const cityInfo = value?.contacts.find(e => e.idDomain === 30)?.address;

          qst.answer = cityInfo?.city || '';
          setFieldValue(qst.key, qst.answer)
        }

        return qst;
      })
    }
  }

  if (question.idQuestion === 1406 && value?.id) {
    saveFilteredQuestionnaire = true;
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1406) {
        qst.answer = JSON.stringify({ id: value.id, value: value.name });
        qst.answerJson = JSON.stringify({ id: value.id, value: value.name });
        setFieldValue(qst.key, value.name)
      }

      if (qst.idQuestion === 1423) {
        qst.fieldMask = value.federalId ? { "mask": "00.000.000/0000-00" } : null;
        qst.answer = "";
        setFieldValue(qst.key, value.federalId || "Não informado")
      }
      return qst;
    })
  }

  if (
    [3447, 3448, 3499].includes(question.idQuestion) &&
    ![254, 400].includes(operation?.idDomain)
  ) {
    saveFilteredQuestionnaire = true;

    handleAdjustmentsAfterCompletedTerms(questionnaire, setFieldValue);
  }

  if (question.idQuestion === 3447 && questionnaire.find(qst => [3403].includes(qst.idQuestion))) {
    saveFilteredQuestionnaire = true;

    const modalityQst = questionnaire.find(qst => [3403].includes(qst.idQuestion));

    // Buscar todas as modalidades selecionadas
    let selectedModalities = [];
    if (modalityQst?.answer) {
      try {
        selectedModalities = Array.isArray(modalityQst.answer)
          ? modalityQst.answer
          : JSON.parse(modalityQst.answer);
      } catch (error) {
        console.error('Erro ao processar modalidades:', error);
      }
    } else if (modalityQst?.idAnswerOption) {
      // Fallback para formato antigo
      const answerOption = modalityQst.answerOptions.find(
        opt => opt.idAnswerOption === modalityQst.idAnswerOption
      );
      if (answerOption) {
        selectedModalities = [{ idAnswerOption: answerOption.idAnswerOption }];
      }
    }

    // Buscar o idProductPlan das modalidades selecionadas
    // Prioridade: 9019, caso contrário pega a primeira
    let idProductPlan = null;
    if (selectedModalities.length > 0) {
      const priorityModality = selectedModalities.find(modality => modality.idAnswerOption === 9019);
      const selectedModality = priorityModality || selectedModalities[0];
      const modalityAnswerOpt = modalityQst.answerOptions.find(
        opt => opt.idAnswerOption === selectedModality.idAnswerOption
      );
      idProductPlan = modalityAnswerOpt?.behaviorObject?.resultProductPlan;
    }

    if (value) {
      const diffDays = dateDiffInDay(new Date(dataReference), new Date(value));

      const idDomainOperation = operation?.isRenewal ? operation?.operationParent?.idDomain : 26;
      const vigencyParamsData = await handleGetProductPlanVigencyParams({
        idProductPlan,
        idDomainOperation,
        inceptionDate: value
      });

      const {
        maxValidityLimitInDays,
        minValidityLimitInDays
      } = handleMaxTermValueInDays(dataReference, value, vigencyParamsData);

      const { productPlanVigencyDefault } = vigencyParamsData;
      questionnaire = questionnaire.map(qst => {
        if ([1555, 1556].includes(qst.idQuestion)) qst.behaviorObject.fieldMinValue = diffDays;

        if (![254].includes(operation?.idDomain)) {
          if (qst.idQuestion === 3448) {
            const endDateTerm = moment(
              moment(value).add(productPlanVigencyDefault, 'days')
            ).format('YYYY-MM-DD');
            qst.answer = endDateTerm
            qst.answerJson = null;
            qst.idAnswerOption = null;
            setFieldValue(qst.key, moment(endDateTerm).format('DD/MM/YYYY'));

            qst.behaviorObject.fieldMaxValue = maxValidityLimitInDays;
            if (minValidityLimitInDays) qst.behaviorObject.fieldMinValue = minValidityLimitInDays;
          }
        }

        if (
          [1556, 1555].includes(qst.idQuestion) &&
          (!operation || operation?.idDomain === 26)
        ) {
          const isBeforeContractLimitDate = moment(new Date(qst.answer)).isBefore(new Date(value));
          if (isBeforeContractLimitDate) {
            qst.answer = null;
            qst.answerJson = null;
            setFieldValue(qst.key, null);

            const modalityQst = questionnaire.find(qst => [3403].includes(qst.idQuestion));

            // Verificar se alguma das modalidades selecionadas é judicial
            let isJudicial = false;
            if (modalityQst?.answer) {
              try {
                const selectedModalities = Array.isArray(modalityQst.answer)
                  ? modalityQst.answer
                  : JSON.parse(modalityQst.answer);
                isJudicial = selectedModalities.some(modality =>
                  [7115, 7116, 7117, 7118, 8162, 8163].includes(modality.idAnswerOption)
                );
              } catch (error) {
                isJudicial = [7115, 7116, 7117, 7118, 8162, 8163].includes(modalityQst?.idAnswerOption);
              }
            } else {
              isJudicial = [7115, 7116, 7117, 7118, 8162, 8163].includes(modalityQst?.idAnswerOption);
            }

            if (!isJudicial) {
              mc.error('A data de inicio de contrato deve ser maior que a de vigência, por favor reinsira a data de inicio e fim de contrato de contrato');
            }
          }
        }
        return qst;
      })

      handleAdjustmentsAfterCompletedTerms(questionnaire, setFieldValue);
    } else {
      const idDomainOperation = operation?.isRenewal ? operation?.operationParent?.idDomain : 26;
      const vigencyParamsData = await handleGetProductPlanVigencyParams({
        idProductPlan,
        idDomainOperation
      });

      const {
        maxValidityLimitInDays,
        minValidityLimitInDays
      } = handleMaxTermValueInDays(dataReference, new Date(dataReference), vigencyParamsData);

      questionnaire = questionnaire.map(qst => {
        if ([1555, 1556].includes(qst.idQuestion)) qst.behaviorObject.fieldMinValue = null;

        if (qst.idQuestion === 3448) {
          qst.answer = null;
          qst.answerJson = null;
          qst.idAnswerOption = null;
          setFieldValue(qst.key, null);
          qst.behaviorObject.fieldMinValue = minValidityLimitInDays;
          qst.behaviorObject.fieldMaxValue = maxValidityLimitInDays;
        }

        if (qst.idQuestion === 3449 && operation?.idDomain !== 254) {
          qst.answer = null;
          qst.answerJson = null;
          setFieldValue(qst.key, null);
        }

        return qst;
      })
    }
  }

  if (question.idQuestion === 3448 && [254].includes(operation?.idDomain)) {
    saveFilteredQuestionnaire = true;

    if (value) {
      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 3447) {
          const days = questionnaire.find(qst => qst.idQuestion === 3449)?.answer;
          qst.answer = moment(value).subtract(days, 'days').format('DD/MM/YYYY');
          setFieldValue(qst.key, qst.answer);
        }
        return qst;
      })

    }
  }

  if (question.idQuestion === 3495) {
    saveFilteredQuestionnaire = true;

    const endorsementNotPreAgreedType = questionnaire.find(
      qst => qst.idQuestion === 3530
    )?.idAnswerOption;

    const inceptionDate = questionnaire.find(qst => qst.idQuestion === 3447).answer;

    let vigencyParamsData = vigencyParams;
    if (operation?.idDomain === 398 && endorsementNotPreAgreedType === 9036) {
      const modalityQst = questionnaire.find(qst => [3403].includes(qst.idQuestion));

      // Buscar modalidades selecionadas
      let selectedModalities = [];
      if (modalityQst?.answer) {
        try {
          selectedModalities = Array.isArray(modalityQst.answer)
            ? modalityQst.answer
            : JSON.parse(modalityQst.answer);
        } catch (error) {
          console.error('Erro ao processar modalidades:', error);
        }
      } else if (modalityQst?.idAnswerOption) {
        // Fallback para formato antigo
        const answerOption = modalityQst.answerOptions.find(
          opt => opt.idAnswerOption === modalityQst.idAnswerOption
        );
        if (answerOption) {
          selectedModalities = [{ idAnswerOption: answerOption.idAnswerOption }];
        }
      }

      // Buscar o idProductPlan das modalidades selecionadas
      // Prioridade: 9019, caso contrário pega a primeira
      let idProductPlan = null;
      if (selectedModalities.length > 0) {
        const priorityModality = selectedModalities.find(modality => modality.idAnswerOption === 9019);
        const selectedModality = priorityModality || selectedModalities[0];
        const modalityAnswerOpt = modalityQst.answerOptions.find(
          opt => opt.idAnswerOption === selectedModality.idAnswerOption
        );
        idProductPlan = modalityAnswerOpt?.behaviorObject?.resultProductPlan;
      }

      vigencyParamsData = await handleGetProductPlanVigencyParams({
        idProductPlan,
        idDomainOperation: operation.idDomain,
        inceptionDate
      });
    }

    const { minValidityLimitInDays } = handleMaxTermValueInDays(
      dataReference,
      inceptionDate,
      vigencyParamsData
    );

    if (value) {
      questionnaire = questionnaire.map(qst => {
        if (
          operation?.idDomain === 398 &&
          endorsementNotPreAgreedType === 9036 &&
          qst.idQuestion === 3499
        ) {
          // qst.answer = null;
          // setFieldValue(qst.key, null);

          // const minDateForCurrentDate = dateDiffInDay(
          //   new Date(dataReference),
          //   new Date(value)
          // );

          // qst.behaviorObject.fieldMinValue = minDateForCurrentDate > minValidityLimitInDays ?
          //   minDateForCurrentDate : minValidityLimitInDays
          //   ;
        }

        return qst;
      });
    } else {
      if (operation?.idDomain === 398 && endorsementNotPreAgreedType === 9036) {
        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 3499) {
            qst.answer = null;
            setFieldValue(qst.key, null);

            qst.behaviorObject.fieldMinValue = minValidityLimitInDays;
          }

          return qst;
        });
      }
    }
  }

  if (question.idQuestion === 1555) {
    saveFilteredQuestionnaire = true;

    if (value) {
      const { diffDays, validity10YearsLimitInDays } = handleGetRangeContractVigency({ dataReference, startDate: value });
      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 1556) {
          qst.behaviorObject.fieldMinValue = diffDays + 1;
          qst.behaviorObject.fieldMaxValue = validity10YearsLimitInDays;
        }

        return qst;
      })
    }
  }


  if ([3403].includes(question.idQuestion)) {
    saveFilteredQuestionnaire = true;

    let selectedPlans = [];
    let selectedModalityOptions = [];

    // Processar múltiplas modalidades
    if (Array.isArray(value)) {
      selectedModalityOptions = value;
      selectedPlans = value
        .map(modality => {
          const answerOption = question.answerOptions.find(
            opt => opt.idAnswerOption === modality.idAnswerOption
          );
          return answerOption?.behaviorObject?.resultProductPlan;
        })
        .filter(plan => plan !== undefined && plan !== null);
    } else {
      // Compatibilidade com formato antigo (modalidade única)
      const answerOption = question.answerOptions.find(
        opt => opt.idAnswerOption === value.idAnswerOption
      );
      const { resultProductPlan } = answerOption?.behaviorObject || {};
      if (resultProductPlan) {
        selectedPlans = [resultProductPlan];
        selectedModalityOptions = [answerOption?.idAnswerOption];
      }
    }

    // Atualizar currentModality com todos os planos selecionados
    setCurrentModality && setCurrentModality(selectedPlans);

    // Buscar parâmetros de vigência para o plano prioritário
    // Prioridade: 9019 > 69012 > primeiro plano
    if (selectedPlans.length > 0) {
      let priorityProductPlan = null;
      if (Array.isArray(value)) {
        const modality9019 = value.find(modality => modality.idAnswerOption === 9019);
        if (modality9019) {
          const answerOption = question.answerOptions.find(
            opt => opt.idAnswerOption === modality9019.idAnswerOption
          );
          priorityProductPlan = answerOption?.behaviorObject?.resultProductPlan;
        }
      }

      const vigencyParamsData = await handleGetProductPlanVigencyParams({
        idProductPlan: priorityProductPlan
          ? priorityProductPlan
          : selectedPlans.find(plan => plan === 69012)
            ? 69012
            : selectedPlans[0],
        idDomainOperation: operation?.idDomain || 26
      });

      handleTypeModalityChange({
        modalityAnswerOpt: selectedModalityOptions,
        idProductPlan: selectedPlans,
        setCurrentModality,
        questionnaire,
        vigencyParamsData,
        dataReference
      });
    }

    if (operation?.idDomain == 26 || !operation) {
      questionnaire = questionnaire.map(qst => {
        if ([3447, 3448, 1569, 3449].includes(qst.idQuestion)) {
          qst.answer = null;
          qst.answerJson = null;
          qst.idAnswerOption = null;
          setFieldValue(qst.key, null);
        }

        return qst;
      })
    }
  }

  if ([3403].includes(question.idQuestion)) {
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1553) {
        // Verificar se alguma das modalidades selecionadas requer o campo
        const isRequired = Array.isArray(value)
          ? value.some(modality => modality.idAnswerOption === 7117 || modality.idAnswerOption === 7118)
          : value.idAnswerOption === 7117 || value.idAnswerOption === 7118;

        return {
          ...qst,
          behaviorObject: {
            ...qst.behaviorObject,
            isRequired
          }
        };
      }

      return qst
    })
  }

  if ([1518, 1621].includes(question.idQuestion) || [3403].includes(question.idQuestion)) {
    const questionPersonBorrower = questionnaire.find(qst => qst.idQuestion === 1518);
    const questionModality = questionnaire.find(qst => [3403].includes(qst.idQuestion));
    const questionResourceType = questionnaire.find(qst => qst.idQuestion === 1621);
    const questionJudicialUpdatedValue = questionnaire.find(qst => qst.idQuestion === 1627);

    // Verificar se alguma das modalidades selecionadas é 7118
    let isModality7118 = false;
    if (questionModality?.answer) {
      try {
        const selectedModalities = Array.isArray(questionModality.answer)
          ? questionModality.answer
          : JSON.parse(questionModality.answer);
        isModality7118 = selectedModalities.some(modality => modality.idAnswerOption === 7118);
      } catch (error) {
        // Fallback para formato antigo
        isModality7118 = questionModality?.idAnswerOption === 7118;
      }
    } else {
      isModality7118 = questionModality?.idAnswerOption === 7118;
    }

    saveFilteredQuestionnaire = true;
    if (questionPersonBorrower?.answer && isModality7118 && questionResourceType?.answer) {
      try {

        const borrowerPersonId = JSON.parse(questionPersonBorrower.answer).id;
        const idProductPlanSelected = questionResourceType.answerOptions
          .find(answerOption => answerOption.idAnswerOption === questionResourceType.idAnswerOption).behaviorObject.resultProductPlan;

        const { data: { coverageMaxLimClaim } } = await useMaxLimClaimRequest(null, {
          idPerson: borrowerPersonId,
          idProductPlanSelected,
          idDomain: 497
        });

        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 1627) {
            return { ...qst, answer: coverageMaxLimClaim ? coverageMaxLimClaim : '0' };
          }
          return qst
        })

        setFieldValue(questionJudicialUpdatedValue.key, coverageMaxLimClaim ? coverageMaxLimClaim : '0');
      } catch (error) {
        console.error(error);
      }


    } else {
      if (questionJudicialUpdatedValue) {
        questionnaire = questionnaire.map(qst => {
          if (qst.idQuestion === 1627) {
            return { ...qst, answer: '' };
          }
          return qst
        })

        setFieldValue(questionJudicialUpdatedValue.key, '');
      }
    }
  }

  if (question.idQuestion === 1575) {
    saveFilteredQuestionnaire = true;

    questionnaire = questionnaire.map(qst => {
      const condition = value?.coinsurerId === '0' || value?.insurerCoinsurerId === '0';
      if ([1575].includes(qst.idQuestion) && condition) {
        qst.answer = null;
        qst.answerJson = null;
        setFieldValue(qst.key, null);

        mc.error(`Cosseguradora sem código externo. Favor verificar.`);
      }
      return qst;
    });

    question.childrenQuestions.map(question => {
      if ([1576].includes(question.idQuestion)) {
        if (value) {
          question.behaviorObject.isRequired = true;
        } else {
          question.behaviorObject.isRequired = false;
        }
      }
      return question;
    })
  }

  if ([3453, 3386].includes(question.idQuestion)) {
    saveFilteredQuestionnaire = true;
    questionnaire = questionnaire.map(qst => {
      if ([3453, 3386].includes(qst.idQuestion) && value?.insurerBrokerId === '0') {
        qst.answer = null;
        qst.answerJson = null;
        setFieldValue(qst.key, null);

        mc.error(`${qst.idQuestion === 3453 ? 'Co-corretor' : 'Corretor'} sem código seguradora. Favor verificar.`);
      }
      return qst;
    });
  }

  if (question.idQuestion === 3431) {
    saveFilteredQuestionnaire = true;
    const { idAnswerOption } = value;
    question.idAnswerOption = idAnswerOption;
    const question3428 = questionnaire.find(qst => qst.idQuestion === 3428);

    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 3470) {
        if (idAnswerOption === 8976) {
          qst.fieldMask = {
            "type": "percentage",
            "mask": "% num",
            "blocks": {
              "num": {
                "mask": 0,
                "scale": 5,
                "signed": true,
                "normalizeZeros": false,
                "padFractionalZeros": true,
                "thousandsSeparator": ",",
                "radix": ".",
                "mapToRadix": [
                  ".",
                  ","
                ],
                "min": -100,
                "max": 100
              }
            }
          };
        } else {
          // Para 8975 ou qualquer outra opção, usar currency
          qst.fieldMask = {
            "type": "currency",
            "mask": 0,
            "scale": 2,
            "signed": false,
            "normalizeZeros": false,
            "padFractionalZeros": true,
            "radix": ",",
            "thousandsSeparator": ".",
            "mapToRadix": [
              ".",
              ","
            ],
            "max": 999999999999.99,
            "min": 0
          };
        }

        // Zerar o campo ao trocar a máscara
        qst.answer = '0';
        setFieldValue && setFieldValue(qst.key, '0');
      }

      // Zerar também o campo 3471 ao trocar a máscara
      if (qst.idQuestion === 3471) {
        qst.answer = '0';
        setFieldValue && setFieldValue(qst.key, '0');
      }

      return qst;
    });
  }

  // Handler para question 3428 (valor total da obra)
  if (question.idQuestion === 3428) {
    question.answer = value;
    saveFilteredQuestionnaire = true;

    // Calcular automaticamente a question 3471
    const shouldSave = calculateQuestion3471(questionnaire, setFieldValue);
    if (shouldSave) saveFilteredQuestionnaire = true;
  }

  // Handler para question 3470 (valor inputado % ou R$)
  if (question.idQuestion === 3470) {
    question.answer = value;
    saveFilteredQuestionnaire = true;

    // Calcular automaticamente a question 3471
    const shouldSave = calculateQuestion3471(questionnaire, setFieldValue);
    if (shouldSave) saveFilteredQuestionnaire = true;
  }

  if (saveFilteredQuestionnaire) setFilteredQuestionnaire(questionnaire);
}


const handleTypeModalityChange = ({
  modalityAnswerOpt,
  idProductPlan,
  setCurrentModality,
  questionnaire,
  vigencyParamsData,
  dataReference
}) => {
  // Normalizar para arrays
  const modalityOptions = Array.isArray(modalityAnswerOpt) ? modalityAnswerOpt : [modalityAnswerOpt];
  const productPlans = Array.isArray(idProductPlan) ? idProductPlan : [idProductPlan];

  questionnaire = questionnaire.map(qst => {
    if (qst.idQuestion === 1619) {
      // Verificar se alguma das modalidades requer o campo
      qst.behaviorObject.isRequired = modalityOptions.some(opt => [7113, 7119, 7120].includes(opt))
        ? false
        : modalityOptions.some(opt => [7116].includes(opt))
          ? true
          : qst.behaviorObject?.isRequired
    } else if (qst.idQuestion === 3447) {
      qst.behaviorObject.fieldMinValue = vigencyParamsData.maxRetroactiveDate;
    } else if (qst.idQuestion === 3448) {
      const {
        maxValidityLimitInDays,
        minValidityLimitInDays
      } = handleMaxTermValueInDays(dataReference, new Date(dataReference), vigencyParamsData);

      qst.behaviorObject.fieldMaxValue = maxValidityLimitInDays;
      if (minValidityLimitInDays) qst.behaviorObject.fieldMinValue = minValidityLimitInDays;
    }
    return qst;
  })

  if (productPlans.length > 0 && productPlans[0]) {
    setCurrentModality && setCurrentModality(productPlans);
  }
}


export const handleRequestSerproCnpj = async (
  rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue) => {

  try {
    questionnaire = questionnaire.map(question => {
      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3388) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3256)) {
        if (data?.nomeEmpresarial) {
          setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
          question.answer = data.nomeEmpresarial;
          question.disabled = true;
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3387) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3255)) {
        if (data?.ni) {
          setFieldValue && setFieldValue(question.key, data.ni);
          question.answer = data.ni;
        }
      }

      if (rootQuestion.idQuestion === 3387 && question.idQuestion === 1536) {
        if (data?.dataAbertura) {
          const date = data?.dataAbertura ? moment(data?.dataAbertura).format('DD/MM/YYYY') : '';
          setFieldValue && setFieldValue(question.key, date);
          question.answer = data.dataAbertura;
        }
      }

      if (rootQuestion.idQuestion === 3387 && question.idQuestion === 1537) {
        if (data?.capitalSocial) {
          setFieldValue && setFieldValue(question.key, String(data.capitalSocial));
          question.answer = String(data.capitalSocial);
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3391 && data?.telefones?.length) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3267 && data?.telefones?.length)) {
        if (data?.telefones) {
          question.answer = data?.telefones[0].ddd + data.telefones[0].numero;
          setFieldValue(question.key, question.answer)
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3392) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3268)) {
        if (data.correioEletronico) {
          setFieldValue && setFieldValue(question.key, data.correioEletronico);
          question.answer = data.correioEletronico;
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3393 && data?.endereco) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3260 && data?.endereco)) {
        if (data?.endereco && data?.endereco?.cep) {
          question.answer = data.endereco.cep;
          setFieldValue(question.key, question.answer)
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3394 && data?.endereco) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3261 && data?.endereco)) {
        if (data?.endereco && data?.endereco?.tipoLogradouro && data?.endereco?.logradouro) {
          question.answer = `${data?.endereco.tipoLogradouro} ${data?.endereco.logradouro}`;
          setFieldValue(question.key, question.answer)
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3395 && data?.endereco) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3262 && data?.endereco)) {
        if (data?.endereco && data?.endereco?.numero) {
          question.answer = data.endereco.numero;
          setFieldValue(question.key, question.answer)
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3397 && data?.endereco) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3264 && data?.endereco)) {
        if (data?.endereco && data?.endereco?.bairro) {
          question.answer = data.endereco.bairro;
          setFieldValue(question.key, question.answer)
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3399 && data?.endereco) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3265 && data?.endereco)) {
        if (data?.endereco && data?.endereco?.uf) {
          question.answer = data.endereco.uf;
          setFieldValue(question.key, question.answer)
        }
      }

      if ((rootQuestion.idQuestion === 3387 && question.idQuestion === 3398 && data?.endereco) ||
        (rootQuestion.idQuestion === 3255 && question.idQuestion === 3266 && data?.endereco)) {
        if (data?.endereco && data?.endereco?.municipio) {
          question.answer = data.endereco.municipio.descricao;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1588) {
        if (data?.nomeEmpresarial) {
          setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
          question.answer = data.nomeEmpresarial;
          question.disabled = true;
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1587) {
        if (data && data.ni) {
          setFieldValue && setFieldValue(question.key, data.ni);
          question.answer = data.ni;
        }
      }

      // if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1536) {
      //   const date = data?.dataAbertura ? moment(data?.dataAbertura).format('DD/MM/YYYY') : '';
      //   setFieldValue && setFieldValue(question.key, date);
      //   question.answer = data.dataAbertura;
      // }

      // if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1537) {
      //   setFieldValue && setFieldValue(question.key, String(data.capitalSocial));
      //   question.answer = String(data.capitalSocial);
      // }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1591 && data?.telefones?.length) {
        if (data?.telefones && data?.telefones.length > 0) {
          question.answer = data?.telefones[0].ddd + data.telefones[0].numero;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1592) {
        if (data?.correioEletronico) {
          setFieldValue && setFieldValue(question.key, data.correioEletronico);
          question.answer = data.correioEletronico;
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1593 && data?.endereco) {
        if (data?.endereco && data?.endereco?.cep) {
          question.answer = data.endereco.cep;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1594 && data?.endereco) {
        if (data?.endereco && data?.endereco?.tipoLogradouro) {
          question.answer = `${data?.endereco.tipoLogradouro} ${data?.endereco.logradouro}`;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1595 && data?.endereco) {
        if (data?.endereco && data?.endereco?.numero) {
          question.answer = data.endereco.numero;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1597 && data?.endereco) {
        if (data?.endereco && data?.endereco?.bairro) {
          question.answer = data.endereco.bairro;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1598 && data?.endereco) {
        if (data?.endereco && data?.endereco?.uf) {
          question.answer = data.endereco.uf;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 1587 && question.idQuestion === 1747 && data?.endereco) {
        if (data?.endereco && data?.endereco?.municipio) {
          question.answer = data.endereco.municipio.descricao;
          setFieldValue(question.key, question.answer)
        }
      }


      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3373) {
        if (data?.nomeEmpresarial) {
          setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
          question.answer = data.nomeEmpresarial;
          question.disabled = true;
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3372) {
        if (data) {
          question.answer = data.ni || data;
          question.answerJson = data.ni || data;
          setFieldValue && setFieldValue(question.key, question.answer);
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 1606) {
        if (data?.dataAbertura) {
          const date = data?.dataAbertura ? moment(data?.dataAbertura).format('DD/MM/YYYY') : '';
          setFieldValue && setFieldValue(question.key, date);
          question.answer = data.dataAbertura;
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 1607) {
        if (data?.capitalSocial) {
          data.capitalSocial = data.capitalSocial / 100;
          setFieldValue && setFieldValue(question.key, String(data.capitalSocial));
          question.answer = String(data.capitalSocial);
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3384 && data?.telefones?.length) {
        if (data?.telefones && data?.telefones.length > 0) {
          question.answer = data?.telefones[0].ddd + data.telefones[0].numero;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3385) {
        if (data?.correioEletronico) {
          setFieldValue && setFieldValue(question.key, data.correioEletronico);
          question.answer = data.correioEletronico;
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3377 && data?.endereco) {
        if (data?.endereco && data?.endereco?.cep) {
          question.answer = data.endereco.cep;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3378 && data?.endereco) {
        if (data?.endereco && data?.endereco?.tipoLogradouro && data?.endereco?.logradouro) {
          question.answer = `${data?.endereco.tipoLogradouro} ${data?.endereco.logradouro}`;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3379 && data?.endereco) {
        if (data?.endereco && data?.endereco?.numero) {
          question.answer = data.endereco.numero;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3381 && data?.endereco) {
        if (data?.endereco && data?.endereco?.bairro) {
          question.answer = data.endereco.bairro;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3382 && data?.endereco) {
        if (data?.endereco && data?.endereco?.uf) {
          question.answer = data.endereco.uf;
          setFieldValue(question.key, question.answer)
        }
      }

      if (rootQuestion.idQuestion === 3372 && question.idQuestion === 3383 && data?.endereco) {
        if (data?.endereco && data?.endereco?.municipio) {
          question.answer = data.endereco.municipio.descricao;
          setFieldValue(question.key, question.answer)
        }
      }

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('handleRequestSerproCnpj error', e)
  }
};

export const dateDiffInDay = (date1, date2) => {
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

  return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
}

const handleMaxTermValueInDays = (dataReference, date, vigencyParams) => {
  const {
    productPlanVigencyMin,
    productPlanVigencyMax
  } = vigencyParams;

  let minValidityLimitInDays = null;
  let maxValidityLimitInDays = null;

  if (productPlanVigencyMin) {
    const minPolicyLimitDate = moment(new Date(date)).add(productPlanVigencyMin, 'days');
    minValidityLimitInDays = dateDiffInDay(new Date(moment(dataReference)), new Date(minPolicyLimitDate));
  }

  if (productPlanVigencyMax) {
    const policyLimitDate = moment(new Date(date)).add(productPlanVigencyMax, 'days');
    maxValidityLimitInDays = dateDiffInDay(new Date(moment(dataReference)), new Date(policyLimitDate));
  }

  return {
    minValidityLimitInDays: minValidityLimitInDays + 1,
    maxValidityLimitInDays: maxValidityLimitInDays + 1
  }
}

const handleAdjustmentsAfterCompletedTerms = (questionnaire, setFieldValue) => {
  const endorsementNotPreAgreedType = questionnaire.find(
    qst => qst.idQuestion === 3530
  )?.idAnswerOption;

  const endorsementChangingPeriod = [9035, 9036].includes(endorsementNotPreAgreedType);

  const dateInit = questionnaire.find(qst => qst.idQuestion === 3447);
  const deadLine = questionnaire.find(qst => qst.idQuestion === (endorsementChangingPeriod ? 3499 : 3448));

  if (dateInit.answer && deadLine.answer) {
    questionnaire = questionnaire.map(qst => {
      if (qst.idQuestion === 1569) {
        const periodYears = moment(deadLine.answer, "YYYY/MM/DD").diff(
          moment(dateInit.answer, "YYYY/MM/DD"), 'years', true
        );

        const periodValidityValue = periodYears < 1 ? 1 : periodYears > 10 ? 10 : periodYears;
        let answerOption = null;

        const modality = questionnaire.find(qst => [3403].includes(qst.idQuestion))?.idAnswerOption;
        if (periodValidityValue && periodValidityValue < 2 && modality === 7116) {
          answerOption = qst.answerOptions.find(aswOpt => aswOpt.idAnswerOption === 7400);
        } else {
          answerOption = qst.answerOptions.find(aswOpt =>
            +aswOpt.dsAnswerOption.replace(/\D/g, '') === Math.ceil(periodValidityValue) &&
            aswOpt.idAnswerOption !== 7400
          );
        }

        qst.idAnswerOption = answerOption?.idAnswerOption;
        qst.answer = answerOption?.dsAnswerOption;
        setFieldValue(qst.key, qst.answer);
      }

      if (qst.idQuestion === 3449) {
        const diffDays = dateDiffInDay(new Date(dateInit.answer), new Date(deadLine.answer));
        qst.answer = diffDays;
        setFieldValue(qst.key, qst.answer);
      }

      return qst;
    })
  }
}

export const handleSearchZipCode = async (rootQuestion, zipCodeData, questionnaire, setFilteredQuestionnaire, setFieldValue) => {
  try {
    questionnaire = questionnaire.map(question => {
      if (question.idQuestion === 1400) {
        if (zipCodeData.LONG_STREET_NAME === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (question.idQuestion === 1399) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (question.idQuestion === 1403) {
        if (zipCodeData.DISTRICT === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        zipCodeData.ZIP_CODE = `${zipCodeData.DISTRICT}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (question.idQuestion === 1404) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (question.idQuestion === 1405) {
        const answerOption = question.answerOptions.find(aswOpt => aswOpt.dsAnswerOption === zipCodeData.STATE);
        const result = {
          idAnswerOption: answerOption?.idAnswerOption,
          dsAnswerOption: answerOption.dsAnswerOption || "",
          resultValue: answerOption?.behaviorAnswerOptionObject?.resultValue != null
            ? answerOption?.behaviorAnswerOptionObject?.resultValue
            : null,
        };

        setFieldValue && setFieldValue(question.key, result);
        return ({ ...question, answer: zipCodeData.STATE, idAnswerOption: result.idAnswerOption });
      }

      // CEP Segurado
      if (rootQuestion.idQuestion == 3377 && question.idQuestion === 3378) {
        if (zipCodeData.LONG_STREET_NAME === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (rootQuestion.idQuestion == 3377 && question.idQuestion === 3377) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (rootQuestion.idQuestion == 3377 && question.idQuestion === 3381) {
        if (zipCodeData.DISTRICT === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        zipCodeData.ZIP_CODE = `${zipCodeData.DISTRICT}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (rootQuestion.idQuestion == 3377 && question.idQuestion === 3383) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (rootQuestion.idQuestion == 3377 && question.idQuestion === 3382) {
        setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
        return ({ ...question, answer: zipCodeData.STATE });
      }

      // CEP Co-Segurado
      if (rootQuestion.idQuestion == 3393 && question.idQuestion === 3394) {
        if (zipCodeData.LONG_STREET_NAME === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (rootQuestion.idQuestion == 3393 && question.idQuestion === 3393) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (rootQuestion.idQuestion == 3393 && question.idQuestion === 3397) {
        if (zipCodeData.DISTRICT === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        zipCodeData.ZIP_CODE = `${zipCodeData.DISTRICT}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (rootQuestion.idQuestion == 3393 && question.idQuestion === 3398) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (rootQuestion.idQuestion == 3393 && question.idQuestion === 3399) {
        setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
        return ({ ...question, answer: zipCodeData.STATE });
      }

      // CEP Beneficiário
      if (rootQuestion.idQuestion == 1593 && question.idQuestion === 1594) {
        if (zipCodeData.LONG_STREET_NAME === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (rootQuestion.idQuestion == 1593 && question.idQuestion === 1593) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (rootQuestion.idQuestion == 1593 && question.idQuestion === 1597) {
        if (zipCodeData.DISTRICT === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        zipCodeData.ZIP_CODE = `${zipCodeData.DISTRICT}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (rootQuestion.idQuestion == 1593 && question.idQuestion === 1747) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (rootQuestion.idQuestion == 1593 && question.idQuestion === 1598) {
        setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
        return ({ ...question, answer: zipCodeData.STATE });
      }

      // CEP Local de Risco
      if (rootQuestion.idQuestion == 3439 && question.idQuestion === 3440) {
        if (zipCodeData.LONG_STREET_NAME === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (rootQuestion.idQuestion == 3439 && question.idQuestion === 3439) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (rootQuestion.idQuestion == 3439 && question.idQuestion === 3443) {
        if (zipCodeData.DISTRICT === 'NA') question.behaviorObject.isReadOnly = false;
        else question.behaviorObject.isReadOnly = true;

        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (rootQuestion.idQuestion == 3439 && question.idQuestion === 3444) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (rootQuestion.idQuestion == 3439 && question.idQuestion === 3445) {
        setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
        return ({ ...question, answer: zipCodeData.STATE });
      }

      return question;
    })

    setFilteredQuestionnaire(questionnaire);
  } catch (error) {
    console.log('handleSearchZipCode error', error)
  }
};


export const onValidationError = (e, mc, formikRef, questionnaire, groupQuestionnaires = []) => {
  console.log("error", e)
  questionnaire = cloneDeep(questionnaire);
  groupQuestionnaires = cloneDeep(groupQuestionnaires);

  mc.error('Por favor, preencha todos os campos obrigatórios para prosseguir.')
  const allQuestions = questionnaire;
  groupQuestionnaires.map(questionnaire => questionnaire.map(question => allQuestions.push(question)));

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question?.key]) continue;
      formikRef.current.setFieldError(question?.key, null);
    }

    const validations = {
      mail: message => {
        if (!message.includes("E-mail")) return "Campo Obrigatório";
        if (message.includes("E-mail")) return "E-mail inválido";
      },
      fone: message => {
        if (!message.includes("Telefone")) return "Campo Obrigatório";
        if (message.includes("Telefone")) return "Telefone inválido";
      },
      importância: message => {
        if (!message.includes("Importância")) return "Campo Obrigatório";
        if (message.includes("Importância")) return "Contrato não pode ser menor que a Importância Segurada";
      },
      vigência: message => {
        if (message.includes("vigência")) return message;
      },
      campo: (message, field) => {
        if (message.includes("Campo")) return `Campo ${field} Obrigatório`;
      },
      atividade: (message, field) => {
        if (message.includes("atividade")) return message;
      }
    };

    e.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question?.key === path);
      if (!question) return;

      Object.keys(validations).forEach(validationKey => {
        if (message.toLowerCase().includes(validationKey)) {
          const error = validations[validationKey](message, question.dsQuestion);
          if (error.toLowerCase().includes("campo")) {
            formikRef.current.setFieldError(question?.key, `* Campo Obrigatório`)
          } else if (error.toLowerCase().includes("atividade")) {
            formikRef.current.setFieldError(question?.key, `* Selecione as atividades corretamente`)
          } else {
            formikRef.current.setFieldError(question?.key, error);
          }
          mc.error(error);
        }
      });

      if (!firstErrorKey) firstErrorKey = question?.key;
    });

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}


export const sectionIsVisible = (sectionName, questionnaire, permissions = {}, currentModality, ignoreVisibilityByModality = false) => {
  const permissionsValues = Object.values(permissions);
  const result = questionnaire
    .some(question => {
      // Ajuste para suportar múltiplas modalidades
      const hasModalityMatch = ignoreVisibilityByModality ||
        !question.productPlans?.length ||
        (Array.isArray(currentModality)
          ? currentModality.some(modality => question.productPlans.includes(modality))
          : question.productPlans.includes(currentModality));

      const result = question?.behaviorObject?.sectionName === sectionName
        && question.visibleQuestion
        && hasModalityMatch
        && (!question?.behaviorObject?.idDomainAccessFilter || !permissionsValues || permissionsValues.includes(question.behaviorObject.idDomainAccessFilter)
          || (Array.isArray(question?.behaviorObject?.idDomainAccessFilter)
            && question.behaviorObject?.idDomainAccessFilter?.length > 0
            && question.behaviorObject?.idDomainAccessFilter?.find(valueBehavior => permissionsValues?.find(value => value === valueBehavior))
          )
        )
      return result;
    }
    );
  //console.log('sectionIsVisible', sectionName, result);
  return result;
}


const getQuestionIsDisabled = (question, operation, isBound) => {
  if (isBound) return true;
  return false;


}


export const groupMultipleFieldQuestions = (mainIdQuestion, questionnaire, operation, isBound) => {
  const groupQuestions = [];

  const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
  for (const mainQuestion of mainQuestions) {
    let group = []
    const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
    if (mainQuestionIndex) group.push(questionnaire[mainQuestionIndex]);
    if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);
    mainQuestion.childrenQuestions.map(childQuestion => group.push(childQuestion));

    group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
    groupQuestions.push(group.map((question, index) => ({ ...question, key: null, disabled: getQuestionIsDisabled(question, operation, isBound) })));
  }

  return groupQuestions;
}


export const removeAnswersDuplicateSession = (questions) => {
  questions = JSON.parse(JSON.stringify(questions));
  return questions.map(question => {
    const { defaultValue } = question.behaviorObject || {};
    question.answer = defaultValue || "";
    question.answerJson = defaultValue || "";
    question.idAnswerOption = null;
    question.idPerson = null;
    question.idQuestionnaireAnswers = null;
    question.idQuestionnaireAnswersParent = null;
    question.idQuestionnaireAnswersRoot = null;
    question.key = null;
    if ([3387, 1587, 1631].includes(question.idQuestion)) question.behaviorObject.isReadOnly = false;
    return question;
  })
}

export const handleGetCoverageMaxLimClaim = async ({ questionnaire, useMaxLimClaimRequest, mc }) => {
  const questionPersonBorrower = questionnaire.find(qst => qst.idQuestion === 1518);
  const questionModality = questionnaire.find(qst => [3403].includes(qst.idQuestion));
  const questionResourceType = questionnaire.find(qst => qst.idQuestion === 1621);

  // Verificar se alguma das modalidades selecionadas é 7118
  let isModality7118 = false;
  if (questionModality?.answer) {
    try {
      const selectedModalities = Array.isArray(questionModality.answer)
        ? questionModality.answer
        : JSON.parse(questionModality.answer);
      isModality7118 = selectedModalities.some(modality => modality.idAnswerOption === 7118);
    } catch (error) {
      // Fallback para formato antigo
      isModality7118 = questionModality?.idAnswerOption === 7118;
    }
  } else {
    isModality7118 = questionModality?.idAnswerOption === 7118;
  }

  let coverageMaxLimClaimValue = null;
  if (
    questionPersonBorrower?.answer &&
    isModality7118 &&
    questionResourceType?.answer &&
    useMaxLimClaimRequest
  ) {
    try {
      const borrowerPersonId = JSON.parse(questionPersonBorrower.answer).id;
      const idProductPlanSelected = questionResourceType.answerOptions
        .find(answerOption => answerOption.idAnswerOption === questionResourceType.idAnswerOption).behaviorObject.resultProductPlan;

      const { data: { coverageMaxLimClaim } } = await useMaxLimClaimRequest(null, {
        idPerson: borrowerPersonId,
        idProductPlanSelected,
        idDomain: 497
      });

      coverageMaxLimClaimValue = coverageMaxLimClaim ? coverageMaxLimClaim : '0';
    } catch (error) {
      console.error(error);
      mc && mc.error('Falha ao buscar IS Máxima da modalide');
    }
  }

  return coverageMaxLimClaimValue;
}

const handleGetRangeContractVigency = ({ dataReference, startDate }) => {
  const diffDays = dateDiffInDay(new Date(dataReference), new Date(startDate));
  const contractLimitDate = moment(new Date(startDate)).add(10, 'y');
  const validity10YearsLimitInDays = dateDiffInDay(new Date(dataReference), new Date(contractLimitDate));

  return {
    diffDays,
    validity10YearsLimitInDays
  }
}